module.exports = __webpack_public_path__ + "img/lead-10z.767a1a9d.png";